document.addEventListener("DOMContentLoaded", function() {
  
let cartTotalValue = document.querySelector('cart-details').getAttribute('data-cart-total');
let exceptions = {};
     let zipCode = document.querySelector('#bg-shipping-calculator-zip-code');
     let state = document.querySelector('#bg-shipping-calculator-state');

 async function fetchShippingCostEstimates(checkZipOnly = false) {

   try {
                      let shippingEstimateRequest = await fetch("".concat(KROWN.settings.routes.cart_url, "/shipping_rates.json?shipping_address[zip]=").concat(zipCode.value, "&shipping_address[country]=").concat("US", "&shipping_address[province]=").concat(state.value), {
                        	credentials: 'same-origin',
                    		method: 'GET'
                      });
     
                      let shippingEstimate = await shippingEstimateRequest.json();
                      let result = shippingEstimate;
     let resultsContainer = document.querySelector('#bg-shipping-calculator-results');

                      if(shippingEstimateRequest.status == 422) {
                        resultsContainer.innerHTML = `<p><strong>Error: ` + result.zip[0] + `</strong></p>`;
                        return false;
                      } else {
                        resultsContainer.innerHTML = "";
                      }
   
                      if(result.shipping_rates && result.shipping_rates.length == 0) {
                        resultsContainer.innerHTML = `<p>Call us at 212-724-4707 for options on this date for this location.</p>`;
                        return false;
                      }

                      let shipTo = "";
                      if(result.shipping_rates[0].code == "bg_ld_man") {
                        shipTo = "manhattan";
                      } else {
                        shipTo = "fedex";
                      }
  let deliveryDateSelect = document.querySelector("#bg-shipping-calculator-requested-delivery-date");

    
                      if(checkZipOnly !== true && result.shipping_rates != null && result.shipping_rates.length > 0 && deliveryDateSelect.value != "---Select Date---") {
                        resultsContainer.innerHTML = "<ul>";
                        result.shipping_rates.forEach( (quote) => {
                          resultsContainer.innerHTML += `<li>${quote.name}: $${quote.price}</li>`
                        });
                        resultsContainer.innerHTML += "</ul>";
                      }

                      if(result.zip) {
                        resultsContainer.innerHTML = `<p>${result.zip.join('<br>')}</p>`;
                      }

     return true;
   } catch(e) {
     console.error("Error: " + e.toString());
   }
  }

function observeCartTotalChanges() {
    // Select the element to observe
    const cartDetails = document.querySelector('#AjaxCartSubtotal');
    // Check if the element exists
    if (!cartDetails) {
        console.error('Element <cart-details> not found.');
        return;
    }

    // Create a MutationObserver instance
    const observer = new MutationObserver((mutationsList) => {

        mutationsList.forEach((mutation) => {
            // Check if the attribute we are interested in has changed
            if (mutation.type === 'childList') {
                cartTotalValue = mutation.target.querySelector('cart-details').getAttribute('data-cart-total');
               let getDeliveryDatesElement = mutation.target.querySelector('#bg-shipping-calculator-get-delivery-dates');
              if(getDeliveryDatesElement) {
                              getDeliveryDatesElement.addEventListener('click', bgShippingDeliveryDateButtonHandler);

              }
                let requestedDeliveryDateElement = mutation.target.querySelector("#bg-shipping-calculator-requested-delivery-date");
                  if(requestedDeliveryDateElement) {
                      requestedDeliveryDateElement.addEventListener("change", deliveryDateSelectionHandler);
                  }
                    zipCode = mutation.target.querySelector('#bg-shipping-calculator-zip-code');
      state = mutation.target.querySelector('#bg-shipping-calculator-state');

              //handling gift message show and hide
let giftMessageElement = mutation.target.querySelector('input[name="attributes[This order is a gift]"]');
              if(giftMessageElement) {
                giftMessageElement.addEventListener("change", function(event) {
  if(event.target.checked == true) {
    document.querySelector('.form-field.gift-message.hidden').classList.remove('hidden'); 
  } else {
        document.querySelector('.form-field.gift-message').classList.add('hidden'); 
  }
});
              }
                      let shippingCalculatorZipCodeElement = mutation.target.querySelector('#bg-shipping-calculator-zip-code');
              if(shippingCalculatorZipCodeElement){
                shippingCalculatorZipCodeElement.addEventListener('keydown', function(event) {
                    // Check if the pressed key is Enter (key code 13)
                    if (event.key === 'Enter') {
                      event.preventDefault();
                        bgShippingDeliveryDateButtonHandler(event); // Run the checkDates function
                    }
                });
              }

         let shippingCalculatorStateElement = mutation.target.querySelector('#bg-shipping-calculator-state');
              if(shippingCalculatorStateElement) {
                shippingCalculatorStateElement.addEventListener('keydown', function(event) {
            // Check if the pressed key is Enter (key code 13)
            if (event.key === 'Enter') {
              event.preventDefault();
                bgShippingDeliveryDateButtonHandler(event); // Run the checkDates function
            }
        });
              }
                resultsContainer = mutation.target.querySelector('#bg-shipping-calculator-results');
                // You can return or do something else with cartTotalValue here
            }
        });
    });

    // Configure and start the observer
    observer.observe(cartDetails, { childList: true });
}

// Call the function to start observing changes
observeCartTotalChanges();

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}


const deliveryDateSelectionHandler = async (event) => {
      const checkoutButton = document.querySelector('button#CheckOut');

  if(event.target.value != '---Select Date---') {
      const minimumOrderNoticeContainer = document.querySelector("#cart_minimum_order_notice");

      const defaultMinimumOrder = 0; //$50.00 in Shopify format
      const dateToCheck = formatDate(new Date(event.target.value));
      let minimumOrder = defaultMinimumOrder;

      if(exceptions.hasOwnProperty(dateToCheck) && cartTotalValue < exceptions[dateToCheck].minimum_order ) {

        minimumOrder = "$" + (exceptions[dateToCheck].minimum_order / 100).toFixed(2);
        minimumOrderNoticeContainer.innerHTML = `<p><strong>For delivery on ${event.target.value}, you will need an order minimum of ${minimumOrder}. Please add more items to your order or select a different delivery date</strong></p>`;
        checkoutButton.disabled = "disabled";
        checkoutButton.type = "button";

      } else if(!exceptions.hasOwnProperty(dateToCheck) && cartTotalValue < defaultMinimumOrder) {

        minimumOrder = "$" + (minimumOrder / 100).toFixed(2);
        minimumOrderNoticeContainer.innerHTML = `<p><strong>The minimum order amount is ${minimumOrder}. Please add more items to your order in order to check out.</strong></p>`;
        checkoutButton.disabled = "disabled";
        checkoutButton.type = "button";

      } else {
     let resultsContainer = document.querySelector('#bg-shipping-calculator-results');

        resultsContainer.innerHTML = 'Fetching shipping estimates <span class="loader"></span>';
        try {
        let lineItems = document.querySelectorAll('input[type="number"][name="updates[]"]');
        let quantityForFirstItem = lineItems[0].value;
        let currentCart = await fetch('/cart.js');
        let currentCartData = await currentCart.json();
          let cartChangeResponse = await fetch('/cart/change.js', {
          method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({line:1, quantity: quantityForFirstItem, properties: {
                  _requestedDeliveryDate: dateToCheck,
                }})
        });
        let updatedCart = await cartChangeResponse.json();
        let orderParametersResponse = await fetch('https://az7pvghrbj.execute-api.us-east-1.amazonaws.com/v1/shipping-quote', {
          method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(currentCartData) 
        });
        let orderParameters = await orderParametersResponse.json();
        let cartAttributeUpdatesResponse = await fetch('/cart/update.js', {
          method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  attributes: {
                    __icePacksNeeded: orderParameters.icePacksNeeded,
                    __insulatedBagsNeeded: orderParameters.insulatedBagsNeeded,
                    __totalOrderWeight: orderParameters.orderWeight + " lbs"
                  }
                })
        });
        await fetchShippingCostEstimates();
        minimumOrderNoticeContainer.innerHTML = "";
            let orderRequestsComments = document.querySelector('.cart__instructions');
  let checkoutContainer = document.querySelector('div.checkout-button-container');
      const checkoutButton = document.querySelector('button#CheckOut');

         checkoutContainer.classList.remove('hidden'); 
          orderRequestsComments.classList.remove('hidden');
        checkoutButton.disabled = false;
        checkoutButton.type = "submit";
        } catch(e) {
          console.error("Error: " + e.toString());
        }
      }
  } else {
        
        checkoutButton.disabled = "disabled";
        checkoutButton.type = "button";
    
  }
    
}

const getDeliveryDates = async (currentTime, zipCode) => {
  
    const exceptionsRequest = await fetch('https://barney-greengrass.s3.us-east-1.amazonaws.com/bg-delivery-date-exceptions.json');
    if(!exceptionsRequest.ok) {
      alert("Something went wrong with the delivery estimator. Please refresh the page and try again.");
    }

    const exceptionsData = await exceptionsRequest.json();
    exceptions = exceptionsData.data;
  
    const tz = 'America/New_York';
    const currentDateTime = new Date(currentTime.toLocaleString("en-US", {timeZone: tz}));
    const currentHour = currentDateTime.getHours();
    const currentDay = currentDateTime.getDay(); // 0 for Sunday, 1 for Monday, ..., 6 for Saturday
    
    const isAfter2pm = currentHour >= 14;
    const tomorrow = new Date(currentDateTime);
    tomorrow.setDate(currentDateTime.getDate() + 1);

    const dates = [];

    // Function to format date as "Monday, July 1, 2024"
    const formatLongDate = (date) => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString("en-US", options);
    };

    if (zipCode.startsWith('100') || zipCode.startsWith('101') || zipCode.startsWith('102')) {
        // Special case for ZIP codes 100, 101, 102
        const thirtyDaysFromTomorrow = new Date(tomorrow);
        thirtyDaysFromTomorrow.setDate(tomorrow.getDate() + 180);

        let date = new Date(tomorrow);
        while (date <= thirtyDaysFromTomorrow) {
          let dateToCheck = formatDate(date);
          let disabled = false;

          //Start with default rules
          if( date.getDay() === 1 ) {
              disabled = "disabled";
          }
          //Apply exception to disable date if applicable
          if(exceptions.hasOwnProperty(dateToCheck) && exceptions[dateToCheck].ship_manhattan === false) {
             // console.log('exception to apply manhattan shipping false', dateToCheck);
              disabled = "disabled";
          }

          //Alternatively apply allowance for date if exception exists
          if(exceptions.hasOwnProperty(dateToCheck) && exceptions[dateToCheck].ship_manhattan === true) {
           // console.log('exception to apply manhattan shipping true', dateToCheck);
            disabled = false;
          }

          let dateLabel = formatLongDate(date) + ((disabled == "disabled") ? ' [Not Available]' : "");
          dates.push({ dateOption: dateLabel, disabled: disabled });
          date.setDate(date.getDate() + 1);
          
        }
    } else {
        // Default case for other ZIP codes

        const minDate = isAfter2pm ? new Date(tomorrow) : new Date(currentDateTime);
        minDate.setDate(minDate.getDate() + 1);

        for (let i = 0; i < 180; i++) {
            const date = new Date(minDate);
            date.setDate(minDate.getDate() + i);
          let dateToCheck = formatDate(date);
          let disabled = false;

          //Start with default rules
          if( date.getDay() === 1 || date.getDay() === 0 || date.getDay() === 2 ) {
              disabled = "disabled"
          }
          
          //Apply exception to disable date if applicable
          if(exceptions.hasOwnProperty(dateToCheck) && exceptions[dateToCheck].ship_fedex === false) {
              disabled = "disabled";
          }

          //Alternatively apply allowance for date if exception exists
          if(exceptions.hasOwnProperty(dateToCheck) && exceptions[dateToCheck].ship_fedex === true) {
              disabled = false;
          }
          
          let dateLabel = formatLongDate(date) + ((disabled == "disabled") ? ' [Not Available]' : "");
          dates.push({ dateOption: dateLabel, disabled: disabled });

        }
    }

    return dates;
};
                                           
  const bgShippingDeliveryDateButtonHandler = async (event) => {
                let orderRequestsComments = document.querySelector('.cart__instructions');
  let checkoutContainer = document.querySelector('div.checkout-button-container');
      const checkoutButton = document.querySelector('button#CheckOut');
    //show loading state
    document.querySelector('#bg-shipping-calculator-get-delivery-dates .loader').classList.remove('hidden');
    
         document.getElementById('bg-shipping-calculator-delivery-date-attribute').classList.add('hidden');

         checkoutContainer.classList.add('hidden'); 
          orderRequestsComments.classList.add('hidden');
        checkoutButton.disabled = true;
        checkoutButton.type = "button";
      event.preventDefault();
      const deliveryDateDropdown = document.querySelector('#bg-shipping-calculator-requested-delivery-date');
      let zipCode = bgShippingEstimator.querySelector('#bg-shipping-calculator-zip-code');
      const shippingCostResults = await fetchShippingCostEstimates(true);
      if(shippingCostResults !== false) {
         let deliveryOptions = await getDeliveryDates(new Date(), zipCode.value);
         let deliveryOptionsElements = '';
         deliveryOptions.forEach( (item) => {
            deliveryOptionsElements += `<option value="${item.dateOption}" ${item.disabled}>${item.dateOption}</option>`;
         });
         deliveryDateDropdown.innerHTML = '<option>---Select Date---</option>' + deliveryOptionsElements;
         document.getElementById('bg-shipping-calculator-delivery-date-attribute').classList.remove('hidden');
      }
        //hide loading state
    document.querySelector('#bg-shipping-calculator-get-delivery-dates .loader').classList.add('hidden');
  };

  let bgShippingEstimator = document.querySelector('#bg-shipping-calculator');
  if(bgShippingEstimator != null) {

    document.querySelector('input[name="attributes[This order is a gift]"]').addEventListener("change", function(event) {
  if(event.target.checked == true) {
    document.querySelector('.form-field.gift-message.hidden').classList.remove('hidden'); 
  } else {
        document.querySelector('.form-field.gift-message').classList.add('hidden'); 
  }
    });

    

  let bgShippingDeliveryDatesButton = document.querySelector('#bg-shipping-calculator-get-delivery-dates');
    let deliveryDateSelect = document.querySelector("#bg-shipping-calculator-requested-delivery-date");

  deliveryDateSelect.addEventListener("change", deliveryDateSelectionHandler);
  bgShippingDeliveryDatesButton.addEventListener('click', bgShippingDeliveryDateButtonHandler);

        document.querySelector('#bg-shipping-calculator-zip-code').addEventListener('keydown', function(event) {
            // Check if the pressed key is Enter (key code 13)
            if (event.key === 'Enter') {
              event.preventDefault();
                bgShippingDeliveryDateButtonHandler(event); // Run the checkDates function
            }
        });


          document.querySelector('#bg-shipping-calculator-state').addEventListener('keydown', function(event) {
            // Check if the pressed key is Enter (key code 13)
            if (event.key === 'Enter') {
              event.preventDefault();
                bgShippingDeliveryDateButtonHandler(event); // Run the checkDates function
            }
        });

  }
  
});
